/** Default dashboard settings */
export const DEFAULT_DASHBOARD_SETTINGS = {
    hierarchyLayout: 'grouped',
    defaultCollapsed: false,
    showEmptyFloors: false,
};
// Standard channel types (from BMS-spec)
export const CHANNEL_TYPES = {
    RELAY: 'relay',
    BUTTON: 'button',
    DIMMER: 'dimmer',
    LED: 'led',
    ANALOG_OUTPUT: 'analog_output',
    PWM_OUTPUT: 'pwm_output',
    READER: 'reader',
    SHADE: 'shade',
    TEMPERATURE: 'temperature',
    CONTACT: 'contact',
    MOTION: 'motion',
    DALI_LIGHT: 'dali_light',
    THERMOSTAT: 'thermostat',
};
export { GRMS_ROLES, isGrmsRole } from './grmsRoles.js';
export { PERMISSIONS, FEDERATED_PROHIBITIONS, isProhibitedForIdentity, projectionCoversScope, grantsAt, hasPermissionAt, canWriteAlarms, canOperateLocks, permissionScopeKey, } from './permissions.js';
export { SCENE_ICONS, GENERIC_SCENE_ICON, isSupportedSceneIcon, isGenericSceneIcon, isValidSceneIconForAuthoring, sceneIconForDisplay, isUnknownStoredSceneIcon, } from './sceneIcons.js';
export { ROOM_TYPES_BY_DOMAIN, getRoomTypesForSiteType, getAllRoomTypes, getRoomTypeLabel, roomTypeLabelKey, } from './roomTypes.js';
//# sourceMappingURL=index.js.map